/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.services.module.ts" />

module App.Common.Services {
	'use strict';

	interface IEnumItemHash {
		[key: string]: IEnumLookupItem;
	}

    class EnumDataService {

        public api: Services.ApiService;
        public $q: angular.IQService;
        public $sessionStorage: Common.ISessionStorage;

        public static $inject = ['$injector'];

        constructor(public $injector: angular.auto.IInjectorService) {
            this.api = $injector.get<Services.ApiService>('app.common.services.apiService');
            this.$q = $injector.get<angular.IQService>('$q');
            this.$sessionStorage = $injector.get<Common.ISessionStorage>('$sessionStorage');
        }
    }

    angular
		.module('app.common.services')
		.service('app.common.services.enumDataService', EnumDataService);
}